/**
 * Fancybox 2 restores `fancybox-lock` only in overlay fadeOut complete.
 * On desktop that callback can miss; leftover overlay keeps capturing wheel.
 */
const UNLOCK_FALLBACK_MS = 400;

function unlockFancyboxScroll(force) {
  const body = document.body;
  body.classList.remove('fancybox-lock');
  body.style.removeProperty('margin-right');

  const fancybox = window.jQuery?.fancybox;
  if (!force && fancybox && (fancybox.isActive || fancybox.isClosing)) {
    return;
  }

  const overlayHelper = fancybox?.helpers?.overlay;
  if (overlayHelper?.el?.removeClass) {
    overlayHelper.el.removeClass('fancybox-lock');
  }

  if (overlayHelper?.overlay) {
    const $overlay = overlayHelper.overlay;
    $overlay.stop(true, true);
    if (overlayHelper.overlay) {
      overlayHelper.overlay.hide();
      overlayHelper.overlay.remove();
      overlayHelper.overlay = null;
    } else {
      $overlay.remove();
    }
    return;
  }

  document.querySelectorAll('.fancybox-overlay').forEach((node) => node.remove());
}

export function initFancyboxSheet() {
  const $ = window.jQuery;
  if (!$ || document.documentElement.dataset.fancyboxSheetUnlock === '1') {
    return;
  }
  document.documentElement.dataset.fancyboxSheetUnlock = '1';

  let unlockTimer = 0;

  $(document).on('beforeClose.fb', () => {
    window.clearTimeout(unlockTimer);
    unlockTimer = window.setTimeout(() => unlockFancyboxScroll(true), UNLOCK_FALLBACK_MS);
  });

  $(document).on('afterClose.fb', () => {
    window.clearTimeout(unlockTimer);
    unlockFancyboxScroll();
  });
}
